import React, { JSX } from "react";
import styled from "styled-components";
import { mobile } from "@ui/styles/utils";
import { InfoIcon } from "./icons";

interface WarningTextProps extends React.HTMLAttributes<HTMLElement> {
	title: string;
	renderElement?: () => JSX.Element;
}

export const WarningText: React.FC<WarningTextProps> = ({ title, renderElement, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{!renderElement ? <InfoIcon /> : renderElement?.()} {title}
		</Container>
	);
};

const Container = styled.div`
	background-color: ${({ theme }) => theme.colors.warning};
	display: flex;
	justify-content: flex-start;
	align-items: center;
	border-radius: 7px;
	gap: 10px;
	font-family: Sora;
	font-style: normal;
	font-weight: normal;
	font-size: 11px;
	line-height: 11px;
	margin-top: 4px;
	padding: 5px 10px;
	@media ${mobile} {
		font-family: Sora;
		font-style: normal;
		font-weight: normal;
		font-size: 10px;
		line-height: 13px;
		color: #000000;
	}
`;
